import { render, staticRenderFns } from "./PccOrderList.vue?vue&type=template&id=98cc2a14&scoped=true&"
import script from "./PccOrderList.vue?vue&type=script&lang=js&"
export * from "./PccOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cc2a14",
  null
  
)

export default component.exports